// src/components/ServiceSection/ServiceSection.jsx
import React from "react";
import { FaCheck } from "react-icons/fa";
import useReveal from "../../hooks/useReveal";
import "./ServiceSection.css";

const ServiceSection = ({ data }) => {
  const { mainTitle, mainDescription, services } = data;
  const gridRef = useReveal({ threshold: 0.1 });

  return (
    <section className="services-section">
      <div className="services-container">
        <h2 className="services-title">{mainTitle}</h2>
        <p className="services-description">{mainDescription}</p>

        <div className="services-grid" ref={gridRef}>
          {services.map((service, index) => (
            <div
              key={service.id}
              className="service-card"
              style={{ "--card-delay": `${index * 120}ms` }}
            >
              <div className="web-service-logo" aria-hidden="true">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature) => (
                  <li key={feature} className="feature-item">
                    <FaCheck className="check-icon" aria-hidden="true" /> {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
